import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { BREAKPOINT_DESKTOP } from "../../constants/Breakpoints";
import { ReactComponent as SearchSvg } from "../../images/search.svg";

function SearchInputView({
  getAutocomplete,
  getButtonProps,
  getInputProps,
  clearSelection,
  inputValue,
  focusInputSearch,
  placeholderText,
  getLabelProps,
}) {
  // Clear search input.
  const clearSearch = () => {
    clearSelection();
  };

  // Clear input on load.
  useEffect(() => {
    clearSelection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const mobileView = window.innerWidth <= BREAKPOINT_DESKTOP - 1;
  return (
    <>
      <div className="searchbar">
        <div className="d-flex">
          <div className="d-flex position-relative align-items-center searchbar__inner pb-8 pb-lg-0">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label
              {...getLabelProps({
                className: "visually-hidden",
              })}
            >
              Search through site
            </label>
            <div className="form-actions">
              <button
                {...getButtonProps({
                  ...getButtonProps,
                  className: "searchbar__search-btn",
                  value: "Search",
                  "aria-label": "Search button",
                })}
                type="submit"
              >
                <SearchSvg />
              </button>
            </div>
            <input
              {...getInputProps({
                ...getInputProps,
                className: "searchbar__box-text",
                onBlur: (event) => {
                  if (mobileView) {
                    // eslint-disable-next-line no-param-reassign
                    event.nativeEvent.preventDownshiftDefault = true;
                  }
                },
                placeholder:
                  placeholderText.length > 0 ? placeholderText : "search",
              })}
              /* eslint-disable-next-line jsx-a11y/no-autofocus */
              autoFocus={focusInputSearch}
            />
            {inputValue && mobileView && (
              <button
                className="searchbar__clear-search popup__button popup__button--close"
                type="button"
                aria-label="Clear search field"
                onClick={clearSearch}
              >
                ×
              </button>
            )}
            {getAutocomplete()}
          </div>
        </div>
      </div>
    </>
  );
}

SearchInputView.defaultProps = {
  focusInputSearch: false,
  placeholderText: "",
};

SearchInputView.propTypes = {
  getAutocomplete: PropTypes.func.isRequired,
  getButtonProps: PropTypes.func.isRequired,
  getInputProps: PropTypes.func.isRequired,
  getLabelProps: PropTypes.func.isRequired,
  clearSelection: PropTypes.func.isRequired,
  inputValue: PropTypes.string.isRequired,
  focusInputSearch: PropTypes.bool,
  placeholderText: PropTypes.string,
};

export default SearchInputView;
